<template>

    <div>

        <h1 class="mt-4"><a href="/quotationsNew/">Offertformulär</a> / {{ quotation.company_name }}</h1>

        <div class="content-container">
            <h2 v-if="quotation.mode == 'contact'">Kontaktförfrågan</h2>
            <h2 v-else>Beställning</h2>

            <div class="row mt-8">

                <div class="col-24 col-lg-10" v-if="quotation.mode == 'contact'">
                    
                    <h3>Kontaktuppgifter</h3>
                    
                    <div class="row mb-1" v-if="quotation.contract_name">
                        <div class="col-6"><strong>Namn</strong></div>
                        <div class="col">{{ quotation.contract_name }}</div>
                    </div>

                    <div class="row mb-1" v-if="quotation.contract_email">
                        <div class="col-6"><strong>E-post</strong></div>
                        <div class="col">{{ quotation.contract_email }}</div>
                    </div>

                    <div class="row mb-1" v-if="quotation.contract_phone">
                        <div class="col-6"><strong>Telefon</strong></div>
                        <div class="col">{{ quotation.contract_phone }}</div>
                    </div>


                    <h3 class="mt-8">Meddelande</h3>

                    <p v-i="quotation.comment">{{ quotation.comment }}</p>

                </div>

                <div class="col-24 col-lg-10" v-if="quotation.mode == 'quotation'">
                    
                    <h3>Företagsuppgifter</h3>
                    
                    <div class="row mb-1" v-if="quotation.company_name">
                        <div class="col-7"><strong>Företagsnamn</strong></div>
                        <div class="col">{{ quotation.company_name }}</div>
                    </div>

                    <div class="row mb-1" v-if="quotation.company_organization_number">
                        <div class="col-7"><strong>Organisationsnr</strong></div>
                        <div class="col">{{ quotation.company_organization_number }}</div>
                    </div>

                    <div class="row mb-1" v-if="quotation.company_address_street">
                        <div class="col-7"><strong>Adress</strong></div>
                        <div class="col">{{ quotation.company_address_street }}<br>{{ quotation.company_address_zip }} {{ quotation.company_address_city }}</div>
                    </div>

                    <div class="row mb-1" v-if="quotation.invoice_email">
                        <div class="col-7"><strong>E-post för faktura</strong></div>
                        <div class="col">{{ quotation.invoice_email }}</div>
                    </div>


                    <h3 class="mt-8">Avtalsansvarig</h3>
                    
                    <div class="row mb-1" v-if="quotation.contract_name">
                        <div class="col-7"><strong>Namn</strong></div>
                        <div class="col">{{ quotation.contract_name }}</div>
                    </div>

                    <div class="row mb-1" v-if="quotation.contract_email">
                        <div class="col-7"><strong>E-post</strong></div>
                        <div class="col">{{ quotation.contract_email }}</div>
                    </div>

                    <div class="row mb-1" v-if="quotation.contract_phone">
                        <div class="col-7"><strong>Telefon</strong></div>
                        <div class="col">{{ quotation.contract_phone }}</div>
                    </div>


                    <h3 class="mt-8" v-if="quotation.contact_name || quotation.contact_email || quotation.contact_phone">Ytterligare kontaktperson</h3>
                    
                    <div class="row mb-1" v-if="quotation.contact_name">
                        <div class="col-7"><strong>Namn</strong></div>
                        <div class="col">{{ quotation.contact_name }}</div>
                    </div>

                    <div class="row mb-1" v-if="quotation.contact_email">
                        <div class="col-7"><strong>E-post</strong></div>
                        <div class="col">{{ quotation.contact_email }}</div>
                    </div>

                    <div class="row mb-1" v-if="quotation.contact_phone">
                        <div class="col-7"><strong>Telefon</strong></div>
                        <div class="col">{{ quotation.contact_phone }}</div>
                    </div>


                    <h3 class="mt-8">Meddelande</h3>

                    <p style="white-space: pre;" v-if="quotation.comment">{{ quotation.comment }}</p>

                </div>


                <div class="col-24 col-lg-12">

                    <h3 v-if="quotation.mode == 'contact'">Prissökning (ej beställning)</h3>
                    <h3 v-else>Beställt abonnemang</h3>

                    <div class="row mb-1" v-if="quotation.num_employees">
                        <div class="col-9"><strong>Antal anställda</strong></div>
                        <div class="col">{{ quotation.num_employees }} st</div>
                    </div>

                    <div class="row mb-1" v-if="quotation.cities">
                        <div class="col-9"><strong>Städer</strong></div>
                        <div class="col">{{ quotation.cities }}</div>
                    </div>

                    <div class="row mb-1" v-if="quotation.treatment_duration">
                        <div class="col-9"><strong>Behandlingslängd</strong></div>
                        <div class="col">{{ quotation.treatment_duration }} minuter</div>
                    </div>

                    <div class="row mb-1" v-if="quotation.num_treatments_requested">
                        <div class="col-9"><strong>Antal behandlingar/år</strong></div>
                        <div class="col">{{ quotation.num_treatments_requested }} st <span v-if="quotation.num_treatments_requested && quotation.num_treatments_requested != quotation.num_treatments_suggested"> (angivet av kunden)</span><span v-else>(Hälsoresurs förslag)</span></div>
                    </div>

                    <div class="row mb-1" v-if="quotation.num_treatments_requested && quotation.num_treatments_requested != quotation.num_treatments_suggested">
                        <div class="col-9"><strong>Föreslagna behandlingar/år</strong></div>
                        <div class="col" style="text-decoration: line-through">{{ quotation.num_treatments_suggested }} st</div>
                    </div>

                    <div class="row mb-1">
                        <div class="col-9"><strong>Pris totalt</strong></div>
                        <div class="col">
                            <span v-if="!quotation.price">Ej offert</span>
                            <span v-else>{{ quotation.price }} kr/mån exkl moms</span>
                        </div>
                    </div>

                    <div class="row mb-1" v-if="quotation.price">
                        <div class="col-9"><strong>Pris per anställd</strong></div>
                        <div class="col">
                            <span>{{ priceByEmployee }} kr/mån exkl moms</span>
                        </div>
                    </div>

                    <div class="row mb-1" v-if="quotation.desired_start_at">
                        <div class="col-9"><strong>Önskat startdatum</strong></div>
                        <div class="col">{{ quotation.desired_start_at.substring(0,10) }}</div>
                    </div>


                </div>

            </div>

        </div>
    </div>

</template>

<script>

export default {

    props: {
        quotation: {
            required: true
        }
    },

    data () {
        return {
        }
    },

    computed: {
        priceByEmployee(){
            return Math.round(this.quotation.price / this.quotation.num_employees)
        },
    },

    methods: {

    }
}
</script>
